<template>
  <div
    class="todo-item"
    :class="{'is-complete': todo.completed}"
    >
    <p>
      <label>
        <input type="checkbox" @change="markComplete" :checked="this.todo.completed" />
        {{ todo.title }}
      </label>
      <button @click="$emit('del-todo', todo.id)" class="del">x</button>
    </p>
  </div>
</template>

<script>
export default {
  name: "TodoItem",
  props: ['todo'],
  methods: {
    markComplete() {
      this.todo.completed = !this.todo.completed;
    },
  }
};
</script>

<style scoped>
.todo-item {
  background: #f4f4f4;
  padding: 10px;
  border-bottom: 1px dotted #ccc;
}

.is-complete {
  text-decoration: line-through;
}

.del {
  background: #f00;
  color: #fff;
  border: none;
  padding: 5px 9px;
  border-radius: 50%;
  cursor: pointer;
  float: right;
}
</style>
